import { Component, HostListener, OnInit } from "@angular/core";
import { ThemeOptions } from "../../../theme-options";
// import {select} from '@angular-redux/store';
import { Observable } from "rxjs";
import { Store, select } from "@ngrx/store";
import { ActivatedRoute } from "@angular/router";
import { CrudService } from "../../../Services/crud.service";
import { LogedInUserService } from "../../../Services/loged-in-user.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  standalone: false,
})
export class SidebarComponent implements OnInit {
  public extraParameter: any;
  isRootUser: boolean = false;
  public config$: Observable<any>;
  constructor(
    public globals: ThemeOptions,
    private activatedRoute: ActivatedRoute,
    private crudService: CrudService,
    private logedInUserService: LogedInUserService,
    private store: Store<{ config: any }>
  ) {
    this.config$ = this.store.pipe(select("config"));
    let self = this;

    self.logedInUserService.get(function (logedInUser) {
      self.crudService.get(
        null,
        function (pResponse) {
          if (pResponse.status === 404) self.isRootUser = false;
          else self.isRootUser = true;
        },
        encodeURI(
          'companyRegistrations/findOne?filter={"where":{"emailId":"' +
            logedInUser.email +
            '"}}'
        )
      );
    });
  }

  // @select('config') public config$: Observable<any>;

  private newInnerWidth: number;
  private innerWidth: number;
  activeId = "pagesMenu";
  private key = "sidebar";
  private userPreference = localStorage.getItem(this.key);

  toggleSidebar() {
    this.globals.toggleSidebar = !this.globals.toggleSidebar;
    this.globals.sidebarHover = !this.globals.toggleSidebar;
    localStorage.setItem(this.key, this.globals.toggleSidebar.toString());
  }

  sidebarHover() {
    this.globals.sidebarHover = !this.globals.sidebarHover;
  }

  sidebarHoverMouseOut() {
    this.globals.sidebarHover = false;
  }

  sidebarHoverMouseIn() {
    this.globals.sidebarHover = true;
  }

  ngOnInit() {
    //TODO: place all user preferences under single variable
    //TODO: for future, store user wise preferences
    this.userPreference = localStorage.getItem(this.key);
    if (
      this.userPreference != null &&
      this.userPreference.toLowerCase() === "true"
    ) {
      this.globals.toggleSidebar = true;
    } else {
      this.globals.toggleSidebar = false;
    }
    localStorage.setItem(this.key, this.globals.toggleSidebar.toString());

    setTimeout(() => {
      this.innerWidth = window.innerWidth;
      if (this.innerWidth < 1200) {
        this.globals.toggleSidebar = true;
      }
    });

    this.extraParameter =
      this.activatedRoute.snapshot.firstChild.data.extraParameter;
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.newInnerWidth = event.target.innerWidth;

    if (this.newInnerWidth < 1200) {
      this.globals.toggleSidebar = true;
    } else {
      this.globals.toggleSidebar =
        localStorage.getItem(this.key).toLowerCase() === "true";
    }

    localStorage.setItem(this.key, this.globals.toggleSidebar.toString());
  }
}
